import { Component } from '@angular/core';
import { GenerationDesignService } from '@project/detail/generation-design/shared/generation-design.service';
import { SystemSelectionTabService } from '@project/detail/generation-design/detail/system-selection-tab/system-selection-tab.service';
import { SystemLoadService } from '@project/detail/load/shared/system-load.service';
import { AcDcCoupledComponent } from '../ac-dc-coupled.component';

@Component({
  selector: 'oes-dc-coupled',
  templateUrl: './dc-coupled.component.html',
  styleUrls: ['./dc-coupled.component.scss']
})
export class DcCoupledComponent extends AcDcCoupledComponent {

  constructor(_generationDesignService: GenerationDesignService,
              _systemSelectionTabService: SystemSelectionTabService,
              _systemLoadService: SystemLoadService) {
    super(_generationDesignService, _systemSelectionTabService, _systemLoadService);
  }
}
